import { Button, Loading } from "@/components";
import {
  FormCheckboxGroup,
  FormDatePicker,
  FormInput,
} from "@/components/Form";
import { Modal } from "@/components/modal/Modal";
import { useMonthlyInspectionDetail } from "../hooks";

const MonthlyInspectionDetail = () => {
  const {
    handleClose,
    open,
    control,
    onSubmit,
    inspectionResultOptions,
    hasAdminComment,
    isSubmitting,
    isAnswered,
    handleCurrentCheckboxs,
    monthlyCheck,
  } = useMonthlyInspectionDetail();

  return (
    <Modal
      open={open}
      onOpenChange={handleClose}
      title={monthlyCheck?.inspection.theme || ""}
      detail="下記の随時点検内容をご覧いただき、店舗の表示を確認いただいた上でご回答をお願いします。"
      classNameTitle="[&_p]:break-all"
    >
      <div className="p-4 space-y-4">
        <FormDatePicker
          control={control}
          name="comfirmation_date"
          label="回答日"
          disabled
          hideIcon
        />

        <FormInput control={control} name="theme" label="テーマ" disabled />

        <FormInput control={control} name="content" label="内容" disabled />

        <div className="space-y-2">
          <p className="text-sm leading-[22px] font-semibold">点検結果</p>
          <FormCheckboxGroup
            control={control}
            name="inspection_results"
            options={inspectionResultOptions}
            direction="vertical"
            className="justify-between w-full px-4 py-2"
            disabled={isAnswered}
            onAfterChange={(value) => {
              handleCurrentCheckboxs(value);
            }}
          />
        </div>

        {hasAdminComment && (
          <FormInput
            control={control}
            name="comments"
            label="コメント"
            multiline
            disabled
          />
        )}
      </div>

      <div className="flex gap-4 justify-end items-center px-4 py-2 border-t border-grey-300 w-full">
        {isAnswered ? (
          <Button
            buttonType="primary"
            className="h-12 rounded-lg px-[22px]"
            onClick={handleClose}
          >
            閉じる
          </Button>
        ) : (
          <>
            <Button
              buttonType="text"
              className="h-12 rounded-lg px-4"
              onClick={handleClose}
            >
              キャンセル
            </Button>

            <Button
              buttonType="primary"
              className="h-12 rounded-lg px-[22px]"
              onClick={onSubmit}
            >
              送信
            </Button>
          </>
        )}
      </div>

      {isSubmitting && <Loading />}
    </Modal>
  );
};

export { MonthlyInspectionDetail };
